import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 col-sm-12" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-6 col-sm-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-4 col-sm-12" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-4 col-sm-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-4 col-sm-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-4 col-sm-12" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-4 col-sm-12" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-md-4 col-sm-12" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-12 col-sm-12 col-xm-12 col-lg-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-12 col-sm-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-12 mt-3" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.createContrat,
        "validation-schema": _ctx.contratSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "codeemp",
                  class: "form-label fw-medium text-black"
                }, [
                  _createTextVNode(" Emplacement "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "codeemp",
                  modelValue: _ctx.codeemp,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeemp) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      "filter-results": false,
                      "min-chars": 2,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                    if (query && query.length >= 2) {

                      const results = await _ctx.fetchEmplacementOptions(query);
                      if (results && results.length > 0) {
                        return results;
                      } else {
                        return [
                          { value: '', label: 'Aucun emplacement trouvé' },
                        ];
                      }
                    } else {
                      return [];
                    }
                  }
                    ,
                      noOptionsText: "Tapez au moins deux caractères",
                      placeholder: "Rechercher un emplacement"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "codeemp",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "matricule",
                  class: "form-label fw-medium text-black"
                }, [
                  _createTextVNode(" Usager "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "matricule",
                  modelValue: _ctx.matricule,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.matricule) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      "filter-results": false,
                      "min-chars": 2,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                    if (query && query.length >= 2) {
                      const results = await _ctx.fetchUsagerOptions(query);
                      if (results && results.length > 0) {
                        return results;
                      } else {
                        return [
                          { value: '', label: 'Aucun usager trouvé' },
                        ];
                      }
                    } else {
                      return [];
                    }
                  }
                    ,
                      noOptionsText: "Tapez au moins deux caractères",
                      placeholder: "Rechercher un usager"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "matricule",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                  _createTextVNode(" Loyer mensuel (FCFA) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "loyer",
                  type: "number",
                  modelValue: _ctx.loyer,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loyer) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "0",
                  step: "0.01",
                  min: "0"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "loyer",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                  _createTextVNode(" Solde initial (FCFA) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "solde_initial",
                  type: "number",
                  modelValue: _ctx.solde_initial,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.solde_initial) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "0",
                  step: "0.01"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "solde_initial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                  _createTextVNode(" Type de solde "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "type_solde",
                  modelValue: _ctx.type_solde,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type_solde) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.typeSoldeOptions,
                      searchable: false,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner un type" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "type_solde",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Durée du contrat ", -1)),
                _createVNode(_component_Field, {
                  name: "duree",
                  type: "text",
                  modelValue: _ctx.duree,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.duree) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "3 ans"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "duree",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Date de signature ", -1)),
                _createVNode(_component_Field, {
                  name: "date_signature",
                  type: "date",
                  modelValue: _ctx.date_signature,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.date_signature) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "date_signature",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Référence ", -1)),
                _createVNode(_component_Field, {
                  name: "reference",
                  type: "text",
                  modelValue: _ctx.reference,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reference) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Référence du contrat"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "reference",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Motif du solde ", -1)),
                _createVNode(_component_Field, {
                  name: "motifsolde",
                  type: "text",
                  modelValue: _ctx.motifsolde,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.motifsolde) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Motif du solde initial"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "motifsolde",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Observation ", -1)),
                _createVNode(_component_Field, {
                  name: "observation",
                  modelValue: _ctx.observation,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.observation) = $event)),
                  as: "textarea",
                  rows: "3",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Observations sur le contrat"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "observation",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: _ctx.loading
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                    : _createCommentVNode("", true),
                  _cache[20] || (_cache[20] = _createTextVNode(" Créer le contrat ", -1))
                ], 8, _hoisted_26),
                _createVNode(_component_router_link, {
                  to: "/liste-contrats",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "fa fa-times lh-1 me-1" }, null, -1),
                    _createTextVNode(" Annuler ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}